import styled from "styled-components";

export const CodeRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const CodeField = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const Period = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
`;
